import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import UserNavigation from "./User/UserNavigation";
import AdminNavigation from "./Admin/AdminNavigation";
import CustomLoading from "../../utils/LoadingIndicator/CustomLoading";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Dashboard = ({ children, title = "Dashboard", description = "" }) => {
  const { user, isLoggedIn } = useAuth();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isAdmin = user?.role === 1;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              {description && (
                <p className="text-gray-600 mt-1">{description}</p>
              )}
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">
                  Welcome back, {user?.name}
                </p>
                <p className="text-xs text-gray-500">
                  {isAdmin ? "Administrator" : "User"}
                </p>
              </div>
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                <span className="text-white font-semibold text-sm">
                  {user?.name?.charAt(0)?.toUpperCase()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-sm border">
              {isAdmin ? (
                <AdminNavigation currentPath={location.pathname} />
              ) : (
                <UserNavigation currentPath={location.pathname} />
              )}
            </div>
          </div>

          {/* Main Content Area */}
          <div className="flex-1">
            <div className="bg-white rounded-lg shadow-sm border min-h-[600px]">
              <div className="p-6">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
